// Marketplace bidding limits — keep in sync with MAX_ACTIVE_OFFERS in backend/server.py.
export const MAX_ACTIVE_BIDS = 8;

// Premium drivers can still bid on a job that already has the maximum bids.
export const isBiddingClosedFor = (activeBidCount, isPremium) =>
  (activeBidCount || 0) >= MAX_ACTIVE_BIDS && !isPremium;
